import { createContext, useEffect, useState } from 'react';
import { Group, GroupResponse, GroupsResponse, Merchant, MerchantsAndGroupsResponse, Payfac, PayfacsResponse, User, UserResponse, UsersResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type UsersContextProps = {
    isLoading: boolean;
    users: User[];
    groups: Group[];
    merchants: Merchant[];
    suggestions: string[];
    totalPage: number;
    loadUsers: (page: number, group: string) => Promise<void>;
    addUser: (user: User) => Promise<string>;
    updateUser: (user: User) => Promise<string>;
    deleteUser: (id: number) => Promise<string>;
    loadMerchantsAndGroups: () => Promise<void>;
    clearSuggestions: () => void;

    loadGroups: () => Promise<Group[]>;
    loadGroupByUser: (user_id: number) => Promise<Group[]>;
    saveGroupByUser: (payload: any) => Promise<string>;
    loadPayfacs: () => Promise<Payfac[]>;


}

export const UsersContext = createContext({} as UsersContextProps);
export const TransactionsContext = createContext({} as UsersContextProps);

export const UsersProvider = ({ children }: any) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [users, setUsers] = useState<User[]>([]);
    const [groups, setGroups] = useState<Group[]>([]);
    const [merchants, setMerchants] = useState<Merchant[]>([]);
    const [suggestions, setSuggestions] = useState<string[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;

    const loadPayfacs = async () => {
        const resp = await topApi.get<PayfacsResponse>('/payfac/getPayfacByUser');

        if (resp.status === 200) {

            return resp.data.payfacs;

        } else
            return [];
    }

    const loadUsers = async (pageActual, group: string) => {
        try {
            setIsLoading(true);
            const resp = await topApi.get<UsersResponse>('/user/getUsersByFI');
            /*if(users.length > 0 && users[0].groups[0].group_name != group){
                setUsers(resp.data.users);
            }*/
            setUsers([...resp.data.users]);
            // setTotalPage(resp.data.pages);
        } catch (error) {

        } finally {
            setIsLoading(false)
        }

    }

    const addUser = async (user: User) => {
        try {

            user.user_id = undefined;

            const resp = await topApi.post<UserResponse>('/user/', { user });
            if (resp.data.error) {
                setSuggestions(resp.data.suggestions);
                return resp.data.error
            } else {
                setUsers([...users, resp.data.user]);
                return 'success'
            }


        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const updateUser = async (user: User) => {
        try {
            const resp = await topApi.put<User>(`/user/${user.user_id}`, { user });

            setUsers(users.map(prod => {
                return (prod.user_id == user.user_id)
                    ? resp.data["user"]
                    : prod;
            }));

            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const deleteUser = async (id: number) => {
        try {
            await topApi.delete<User>(`/user/${id}`);
            setUsers((prevUsers) =>
                prevUsers.filter((user) => user.user_id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const loadMerchantsAndGroups = async () => {

        const resp = await topApi.get<MerchantsAndGroupsResponse>('/user/getMerchantsAndGroups');
        setGroups([...resp.data.groups]);
        setMerchants([...resp.data.merchants]);

    }

    const clearSuggestions = () => {
        setSuggestions([]);
    }



    const loadGroupByUser = async (userId: number) => {

        const resp = await topApi.get<GroupsResponse>('/group/getGroupsByUser/' + userId);
        if (resp.status == 200) {
            return resp.data.groups;
        } else {
            return [];
        }
    }

    const loadGroups = async () => {
        //setIsloading(true);
        try {
            const resp = await topApi.get<GroupsResponse>('/group/getGroups');
            if (resp.status == 200) {
                return resp.data.groups;
                //setGroups([...resp.data.groups]);
                //setTotalPage(1);
            }
        } catch (error) {

        } finally {
            //setIsloading(false)
        }
    }

    const saveGroupByUser = async (payload: any) => {
        try {
            const resp = await topApi.post<GroupResponse>('/group/saveGroupByUser', payload);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    return (
        <UsersContext.Provider value={{
            isLoading,
            users,
            groups,
            merchants,
            suggestions,
            totalPage,
            loadUsers,
            addUser,
            updateUser,
            deleteUser,
            loadMerchantsAndGroups,
            clearSuggestions,
            loadGroupByUser,
            loadGroups,
            saveGroupByUser,
            loadPayfacs
        }}>
            {children}
        </UsersContext.Provider>
    );
}